module.exports = __webpack_public_path__ + "img/menu.a4c5ba4f.png";